import { batch } from 'react-redux';

import { preprocessAppOptions } from './utils';
import { getAppConfigs } from '../../api/app-configs';
import { handleAppSettingsForCacheDB } from '../../utils/indexedDB.cache.utils';
import { handleErrors } from '../ErrorActions';

export const FETCH_APP_OPTIONS = 'FETCH_APP_OPTIONS';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const FETCH_APP_SETTINGS = 'FETCH_APP_SETTINGS';
export const FETCH_ORG_HIERARCHY = 'FETCH_ORG_HIERARCHY';

export const fetchAppConfigs = () => async (dispatch) => {
  const {
    appOptionsResponse,
    fetchLanguagesResponse,
    appSettingsResponse,
    orgHierarchyResponse,
  } = await getAppConfigs();

  const responses = [
    appOptionsResponse,
    fetchLanguagesResponse,
    appSettingsResponse,
    orgHierarchyResponse,
  ];

  for (const response of responses) {
    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }
  }

  handleAppSettingsForCacheDB(appSettingsResponse.ApplicationSettings);

  batch(() => {
    dispatch({
      type: FETCH_APP_OPTIONS,
      appOptions: preprocessAppOptions(appOptionsResponse.ApplicationOptions),
    });
    dispatch({
      type: SET_LANGUAGES,
      payload: fetchLanguagesResponse.languages,
    });
    dispatch({
      type: FETCH_APP_SETTINGS,
      appSettings: appSettingsResponse.ApplicationSettings,
    });
    dispatch({
      type: FETCH_ORG_HIERARCHY,
      orgHierarchy: orgHierarchyResponse.OrganizationHierarchy,
    });
  });
};
